import React, { Fragment, useEffect, useState } from "react";

export const ErrorPage = (props) => {
  return <div style={{ margin: 24 }}>Store Non Trovato</div>;
};
